import { useCallback, useMemo, MouseEvent } from "react";
import { useFetchCustomerData } from "../../Payoff/components/PayoffForm/hooks/useFetchCustomerData";
import { FormInstance, MenuProps, Row } from "antd";

type TDropdownParams = {
  primaryBuyerId: string;
  primarySellerId: string;
  form: FormInstance;
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useDropdown = ({
  primaryBuyerId,
  primarySellerId,
  form,
  setHasChanges,
}: TDropdownParams) => {
  const { isLoading, data } = useFetchCustomerData(
    primaryBuyerId,
    primarySellerId
  );

  const onDropdownChange = useCallback(
    (e: MouseEvent<HTMLInputElement>) => {
      if (data) {
        const id = e.currentTarget.id;

        const { primaryBuyer, primarySeller } = data;

        const value = id === "1" ? primaryBuyer : primarySeller;

        form.setFieldValue("propertyAddress", value?.receiver.addressLine);
        setHasChanges(true);
      }
    },
    [data, form, setHasChanges]
  );

  const items: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: (
          <Row id={"1"} onClick={onDropdownChange}>
            Set Primary Buyer Address
          </Row>
        ),
      },
      {
        key: "2",
        label: (
          <Row id={"2"} onClick={onDropdownChange}>
            Set Primary Seller Address
          </Row>
        ),
      },
    ],
    [onDropdownChange]
  );

  return { items, isLoading };
};
